import RecoverStep from "../recover_step";

const TEMPLATE = 'virtualization-start-runbook-failover';

export default class CreateRunbookFailover extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.render = {
            hasError: false,
            runbookName: data.recovery.virtualization.runbook.name
        };

        data.recovery.defer = $.Deferred();
        data.recovery.defer.done(function() {
            fr.close();
            tabs_goto('client/details/' + data.clientId + '/1', 'li.clients-tab');
        }).fail(function(reason) {
            data.render.hasError = true;
            if (reason) {
                data.render.error = reason['_message_'];
            }
            fr.render('createRunbookFailover');
        }).always(function() {
            pollMeister.unsubscribe('runbook_failover_status/' + data.recovery.virtualization.runbook.id);
        });
        fr.callMethod('checkRunbookFailoverStatus');
    }

    checkRunbookFailoverStatus(data, el, fr) {
        pollMeister.subscribe('runbook_failover_status/' + data.recovery.virtualization.runbook.id, function(response) {
            if (response.vo_created) {
                data.recovery.vo_id = response.vo_id;
                data.recovery.defer.resolve();
            } else if (response.vo_error) {
                data.recovery.defer.reject(response.errors);
            }
        }, null);
    }

}
